/**
 * @generated SignedSource<<bb5bc2749b4b4e3b7a2489bf636bd50c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "LiqPaySignResponse",
    "kind": "LinkedField",
    "name": "liqPaySign",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signature",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImpulseLiqPaySignPaymentCheckoutPagesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImpulseLiqPaySignPaymentCheckoutPagesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e45904ec0e4037330a7e056dd66e6876",
    "id": null,
    "metadata": {},
    "name": "ImpulseLiqPaySignPaymentCheckoutPagesMutation",
    "operationKind": "mutation",
    "text": "mutation ImpulseLiqPaySignPaymentCheckoutPagesMutation(\n  $request: LiqPaySignRequestInput\n) {\n  liqPaySign(request: $request) {\n    signature\n    data\n  }\n}\n"
  }
};
})();

node.hash = "08ecae923cb14333d059cea5c5462c1b";

module.exports = node;
